<template>
  <div class="modal fade" id="refundModal2" tabindex="-1" role="dialog" aria-labelledby="refundModalLabel" style="display:none">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title text-primary" id="forgot_ModalLabel"><i class="fa fa-euro mr-5"></i>Gutschrift ohne Warenbewegung</h4>
        </div>
        <div class="modal-body">
          <h4>Sind Sie sicher, dass Sie eine Gutschrift für diesen Artikel verbuchen möchten?</h4>
          <p class="text-primary"><i class="fa fa-warning mr-5"></i>Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
          <div class="margin"></div>
          <label>Betrag:</label>
          <input v-model="value" v-validate="{required: true, maxRefund: line.refundable_amount, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" data-vv-as="Amount" class="form-control" name="amount" type="text">
          <span v-show="errors.has('amount')" class="small text-danger">{{ errors.first('amount') }}</span>
          <div class="margin"></div>
          <label>Kommentar:</label>
          <textarea class="form-control" v-model="message" v-validate="'required'" data-vv-as="Message" name="message"></textarea>
          <span v-show="errors.has('message')" class="small text-danger">{{ errors.first('message') }}</span>
        </div>
        <div class="modal-footer">
          <button @click="() => {compLine = {}; value = ''; message = ''}" type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Abbrechen</button>
          <button :disabled="errors.any()" type="button" class="btn btn-app no-margin btn-success" data-dismiss="modal" @click="post"><span class="fa fa-save"></span>Speichern</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['line'],
    data () {
      return {
        value: '',
        message: '',
        compLine: this.line
      }
    },
    methods: {
      post () {
        let obj = {
          type: 'reduction',
          message: this.message,
          requested_reduction: parseFloat(this.value.replace(',', '.'))
        }
        this.$validator.validate()
          .then(result => {
            if (!result) {
              this.$emit('error')
            } else {
              API.post(`/orders/line/${this.line.id}/case/reduction`, obj)
                .then(res => {
                  this.value = ''
                  this.message = ''
                  this.$emit('success')
                })
            }
          })
      }
    },
    mounted () {
      this.$validator.extend('maxRefund',{
        getMessage: (field, [testProp]) => `The ${field} field cannot be larger than the refundable amount: ${testProp}`,
        validate: (value, [testProp]) => {
          let test = parseFloat(value.toString().replace(',', '.'))
          return test <= testProp
        }
      })
    },
    watch: {
      line () {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/RefundModal2.vue